module.exports = __webpack_public_path__ + "prod/20260124143402/img/logo_v2.a0a47605.png";